export const TITLE_SUFFIX = ' » Mezmo'
export const DEFAULT_MARKER_FORMAT = 'dddd, MMM Do YYYY, h:mma'
export const COPYRIGHT_TEXT = `© 2013–${new Date().getFullYear()} Mezmo, Inc.`

export const DEFAULT_TCP_SYSLOG_HOST = 'syslog-a'
export const DEFAULT_UDP_SYSLOG_HOST = 'syslog-u'
export const VALID_APP_HOSTS = ['logdna.com', 'mezmo.com']
export const DEFAULT_HOST = window?.LD?.constants?.DEFAULT_HOST || 'logdna.com'// optionally chain for tests to pass....
export const DEFAULT_API_HOST = 'api.' + DEFAULT_HOST
export const DEFAULT_INGESTION_HOST = 'logs.' + DEFAULT_HOST
export const DOCS_URL = 'https://docs.mezmo.com'
export const STATUS_URL = 'https://status.mezmo.com'
export const SUPPORT_URL = 'https://www.mezmo.com/contact-us'
export const DEFAULT_AGENT_DS_YAML = 'https://raw.githubusercontent.com/logdna/logdna-agent/master/logdna-agent-ds.yaml'
export const DEFAULT_AGENT_OPENSHIFT_DS_YAML = 'https://raw.githubusercontent.com/logdna/logdna-agent/master/logdna-agent-ds-os.yaml'
export const DEFAULT_AGENT_KUBERNETES18_DS_YAML = 'https://raw.githubusercontent.com/logdna/logdna-agent/master/logdna-agent-ds-k8s-v1.8.yaml'
export const DEFAULT_AGENT_KUBERNETES_NAMESPACE = 'logdna-agent'
export const DEFAULT_AGENT_KUBERNETES_NAMESPACE_YAML = 'https://assets.logdna.com/clients/logdna-agent/3/agent-namespace.yaml'
export const DEFAULT_AGENT_KUBERNETES_RESOURCES_YAML = 'https://assets.logdna.com/clients/logdna-agent/3/agent-resources.yaml'
export const DEFAULT_ROOT_CA_URL = 'https://repo.logdna.com/syslog/ld-root-ca.crt'

export const FRAME_CONTENT_ENDPOINT = '/modules/frame-content'
export const USAGE_DATA_ENDPOINT = '/modules/usage-data'
export const PROVISION_SYSLOG_ENDPOINT = '/modules/provision-syslog'
export const SWITCH_ACCOUNT_ENDPOINT = '/modules/account-switch'
export const REAUTH_ENDPOINT = '/account/reauthenticate'

export const FAVORITES_ENDPOINT = '/modules/user-prefs/favorites'
export const RECENT_SEARCHES_ENDPOINT = '/logs/recent-searches'

export const SEARCH_ENDPOINT = '/logs/lines'
export const HISTOGRAM_ENDPOINT = '/logs/histogram'

export const K8S_RESOURCE_ENDPOINT = '/logs/k8s-resource'

export const LOG_VIEWER_ROOT = '/logs/view'
export const SAVE_VIEW_ENDPOINT = '/logs/view/save'
export const DELETE_VIEW_ENDPOINT = '/logs/view/delete'
export const SAVE_VIEW_PROPS_ENDPOINT = '/logs/view/props'
export const EXPORT_LINES_ENDPOINT = '/logs/export'
export const GET_VIEW_DATA_ENDPOINT = '/logs/view/populate'
export const GET_VIEWER_SETTINGS_ENDPOINT = '/logs/settings'

export const LINE_TOKEN = '$@'
export const DEFAULT_LINE_FORMAT = '%time_1|%host|%app|%level|%line'
export const DEFAULT_LINE_FORMAT_FEDERATED_SEARCH = '%time_1|%org|%host|%app|%level|%line'
export const LINE_ENDPOINT = '/logs/line'
export const SEARCH_LINES_ENDPOINT = '/logs/lines'
export const LINE_CONTEXT_ENDPOINT = '/logs/line-context'
export const LINES_BY_CONTEXT_ENDPOINT = '/logs/lines-by-context'
export const CONTEXTUAL_UI_MODULE = '/modules/contextual-ui'

export const AVAILABLE_FIELDS_ENDPOINT = '/logs/fields'
export const VALUE_DISTRIBUTION_ENDPOINT = '/logs/field-values'

export const FILTERS_ENDPOINT = '/modules/filters'

export const GROUP_PREFIX = 'g::'
export const SAVE_GROUP_ENDPOINT = '/modules/groups/save'
export const DELETE_GROUP_ENDPOINT = '/modules/groups/delete'

export const GRAPHS_ROOT = '/graphs/board'
export const GET_GRAPH_DATA_ENDPOINT = '/graphs/board/populate'
export const RENDER_GRAPH_ENDPOINT = '/graphs/render'
export const SAVE_GRAPH_ENDPOINT = '/graphs/board/save-graph'
export const REMOVE_GRAPH_ENDPOINT = '/graphs/board/remove-graph'
export const SAVE_BOARD_SETTINGS_ENDPOINT = '/graphs/board/settings'
export const DUPLICATE_BOARD_ENDPOINT = '/graphs/board/duplicate'

export const SCREENS_ROOT = '/screens/screen'
export const GET_SCREEN_DATA_ENDPOINT = '/screens/populate-widgets'
export const SAVE_SCREEN_ENDPOINT = '/screens/save-screen'
export const DUPLICATE_SCREEN_ENDPOINT = '/screens/duplicate-screen'
export const DELETE_SCREEN_ENDPOINT = '/screens/delete-screen'
export const RENDER_WIDGET_ENDPOINT = '/screens/render'

export const EVERYTHING_SENTINEL_VALUE = '__ALL_LINES__'
export const MAX_PLOTS_PER_GRAPH = 30
export const MAX_SUBPLOTS_PER_GRAPH = 5
export const MAX_RETENTION_DAYS = 100

// enterprise endpoints
export const ENTERPRISE_ENDPOINT = '/enterprises'
export const ENTERPRISE_SAML_CONFIG_ENDPOINT = id => `/enterprises/${id}/saml`

// user prefs endpoints
export const USER_PREFS_SET_ENDPOINT = '/modules/user-prefs/set'
export const USER_PREFS_CHANGE_PASSWORD_ENDPOINT = '/modules/user-prefs/change-password'
export const USER_PREFS_OTP_ENDPOINT = '/modules/user-prefs/otp'
export const USER_PREFS_OTP_STATE_ENDPOINT = '/modules/user-prefs/otp/state'
export const USER_PREFS_OTP_ACTIVATE_ENDPOINT = '/modules/user-prefs/otp/activate'

// manage profile endpoints
export const GET_INTEGRATIONS_ENDPOINT = '/manage/get-integrations'
export const INTEGRATIONS_ENDPOINT = '/manage/integrations'
export const INTEGRATION_USAGE_ENDPOINT = '/manage/integration-usage'
export const INTEGRATION_UPDATE_URL = '/manage/integrations/update'
export const FIELDSET_TEMPLATE_URL = '/modules/integration-fieldset'
export const AUTH_STATUS_URL = '/modules/auth-status'
export const MANAGE_ACCOUNT_PROFILE_ENDPOINT = '/manage/profile/account'
export const INGESTION_KEY_MANAGE_ENDPOINT = '/manage/profile/ingestion-keys'
export const SERVICE_KEY_MANAGE_ENDPOINT = '/manage/profile/service-keys'
export const GET_TEAM_MEMBERS_ENDPOINT = '/manage/get-team-members'
export const CONFIG_STATS_ENDPOINT = '/manage/profile/account-config-stats'
export const EXPORT_CONFIG_ENDPOINT = '/manage/profile/export-account-config'
export const IMPORT_CONFIG_ENDPOINT = '/manage/profile/import-account-config'
export const CHANGE_OWNER_ENDPOINT = '/manage/profile/begin-change-owner'
export const WHITELIST_DOMAIN_MANAGE_ENDPOINT = '/manage/profile/whitelist-domain'
export const ACTIVATE_ACCOUNT_ENDPOINT = '/account/org/activate'
export const CREATE_ORG_ENDPOINT = '/account/org/create'

// manage alerts endpoints
export const LIST_ALERTS_ENDPOINT = '/manage/alerts'
export const DELETE_VIEW_SPECIFIC_ALERT_ENDPOINT = '/manage/alerts/view-specific'
export const DELETE_ALERT_PRESET_ENDPOINT = '/manage/alerts/preset'
export const SAVE_VIEW_SPECIFIC_ALERT_ENDPOINT = '/manage/alerts/view-specific'
export const SAVE_ALERT_PRESET_ENDPOINT = '/manage/alerts/preset'
export const UNMUTE_ALERT = '/manage/alerts/unmute'
export const TEST_ALERT = '/manage/alerts/test'
export const UNMUTE_ALERT_MOSTLY_THE_SAME = '/ext/unmute-alert'

// manage archiving endpoints
export const MANAGE_ARCHIVING_ENDPOINT = '/manage/archiving'

// manage rehydration endpoints
export const REHYDRATIONS_ENDPOINT = '/manage/rehydrations'
export const REHYDRATIONS_RETRY_ENDPOINT = '/manage/rehydrations/retry'
export const REHYDRATIONS_ARCHIVES_ENDPOINT = '/manage/rehydrations/archives'

// manage categories endpoints
export const REMOVE_FROM_CATEGORY_ENDPOINT = '/manage/categories/remove-from-category'
export const ADD_TO_CATEGORY_ENDPOINT = '/manage/categories/add-to-category'
export const ADD_CATEGORY_ENDPOINT = '/manage/categories/add-category'
export const REMOVE_CATEGORY_ENDPOINT = '/manage/categories/remove-category'
export const EDIT_CATEGORY_ENDPOINT = '/manage/categories/edit-category'

// manage team endpoints
export const MODIFY_PERMISSIONS_ENDPOINT = '/manage/team/modify-permissions'
export const ADD_MEMBER_ENDPOINT = '/manage/team/add-member'
export const REMOVE_MEMBER_ENDPOINT = '/manage/team/remove-member'
export const IDP_METADATA_PARSE_ENDPOINT = '/manage/team/parse-idp-metadata'
export const SAML_CONFIG_ENDPOINT = '/manage/configure-saml'
export const ACCEPT_JOIN_REQUEST_ENDPOINT = '/manage/team/join-request/accept'
export const REJECT_JOIN_REQUEST_ENDPOINT = '/manage/team/join-request/reject'

// manage plan endpoint
export const CHANGE_PLAN_ENDPOINT = '/manage/plan/change'
export const EXTEND_TRIAL_PLAN_ENDPOINT = '/manage/plan/trial/extend'

// manage billing endpoint
export const BILLING_DETAIL_ENDPOINT = '/manage/billing/details'
export const BEGIN_CHECKOUT = '/manage/billing/begin-checkout'
export const COMPLETE_CHECKOUT = '/manage/billing/complete-checkout'
export const CREATE_SETUP_INTENT = '/manage/billing/create-setup-intent'
export const SET_PAYMENT_METHOD = '/manage/billing/set-payment-method'
export const SAVE_BILLING_SETTINGS = '/manage/billing/save-settings'
export const PAY_OUTSTANDING_ENDPOINT = '/manage/billing/pay-outstanding'

// manage usage endpoint
export const GET_CONTROLS_ENDPOINT = '/manage/ingestion/get-controls'
export const SAVE_CONTROLS_ENDPOINT = '/manage/ingestion/save-controls'
export const LIST_RULES_ENDPOINT = '/manage/ingestion/list-rules'
export const UPDATE_RULE_ENDPOINT = '/manage/ingestion/update-rule'
export const TOGGLE_RULE_ENDPOINT = '/manage/ingestion/toggle-rule'

// manage usage quota endpoints
export const GET_USAGE_QUOTAS_ENDPOINT = '/manage/usage-quotas/settings'
export const TOGGLE_USAGE_QUOTAS_ENDPOINT = '/manage/usage-quotas'
export const UPDATE_USAGE_QUOTAS_ENDPOINT = '/manage/usage-quotas/quota'
export const UPDATE_USAGE_QUOTAS_RECIPIENTS_ENDPOINT = '/manage/usage-quotas/recipients'
export const CRUD_USAGE_QUOTAS_RULE_ENDPOINT = '/manage/usage-quotas/rules'

// manage index rate alerts endpoints
export const CRUD_INDEX_RATE_ALERT_CONFIG_ENDPOINT = '/manage/index-rate-alerts'

// analytics endpoints
export const USAGE_HISTORY_ENDPOINT = '/manage/analytics/history'
export const FLOW_RATE_HISTORICAL_ENDPOINT = '/manage/analytics/flow-rate-historical'
export const FLOW_RATE_CURRENT_HOUR_ENDPOINT = '/manage/analytics/flow-rate-current-hour'
export const SOURCES_BREAKDOWN_ENDPOINT = '/manage/analytics/sources-breakdown'
export const TRENDS_ENDPOINT = '/manage/analytics/trends'

// endpoints to create or reset a password
export const ACCOUNT_SETUP_PASSWORD_ENDPOINT = '/account/setup/change-password'
export const CHANGE_PASSWORD_ENDPOINT = '/account/reset-password'
export const FORGOT_PASSWORD_ENDPOINT = '/account/forgot-password'

// maps a typed email to its enterprise SSO init URL (single sign-on tab)
export const SSO_DISCOVERY_ENDPOINT = '/auth/sso-discovery'

// endpoints to create or reset a password
export const VERIFY_EMAIL_URL = '/account/verify-email'
export const RESEND_VERIFICATION_URL = '/account/resend-verification'

// custom parsing endpoints
export const GET_CUSTOM_PARSING_TEMPLATES_ENDPOINT = '/manage/custom-parsing'
export const CREATE_PARSING_TEMPLATE_ENDPOINT = '/manage/custom-parsing/create-template'
export const CREATE_TEMPLATE_DRAFT_ENDPOINT = '/manage/custom-parsing/create-draft'
export const EDIT_TEMPLATE_ENDPOINT = '/manage/custom-parsing/edit-template'
export const ACTIVATE_TEMPLATE_ENDPOINT = '/manage/custom-parsing/activate-template'
export const PRIORITIZE_TEMPLATES_ENDPOINT = '/manage/custom-parsing/prioritize-templates'
export const REMOVE_CUSTOM_PARSING_TEMPLATE_ENDPOINT = '/manage/custom-parsing/remove-template'

// extract fields endpoints
export const EXTRACT_FIELDS_ENDPOINT = '/manage/extract-fields/extract-fields'

// Template Library endpoints
export const TEMPLATE_LIBRARY_ENDPOINT = '/manage/template-library/templates'
export const TEMPLATE_LIBRARY_ENDPOINT_DETECT = '/manage/template-library/templates/detect'

// Variable Retention
export const VARIABLE_RETENTION_ENDPOINT = '/manage/variable-retention'

// Pipeline Endpoints
// NOTE:These are not in ldw but are proxied to the pipeline api
// See proxies/pipeline.js for proxy code.
// all /p routes get proxied and rewritten as /
export const PIPELINE_PROXY = '/v3/pipeline'
export const PIPELINE_ROOT = '/pipelines'
export const PIPELINE_DASHBOARD = `${PIPELINE_ROOT}/dashboard`
export const TRANSFORM_GROUP_PROXY = '/v3/transform-group'

export const AI_INVESTIGATIONS_ROOT = '/ai-investigations'
export const AI_INVESTIGATIONS_LIST = `${AI_INVESTIGATIONS_ROOT}/list`

// Auth provider endpoints
export const AUTH_PROVIDER_PROXY = '/v3/auth'
export const ENTERPRISE_AUTH_PROVIDER_PROXY = '/v3/enterprise/auth'
export const ENTERPRISE_PROXY = '/v3/enterprise'

// Aura endpoints (ai chat)
export const AURA_PROXY = '/v1/aura'

// Trace Analysis endpoints
export const TRACE_ANALYSIS_PROXY = '/trace-analysis'

// AI History endpoints
export const AI_HISTORY_PROXY = '/ai/history'

// Notifications
export const NOTIFICATIONS = '/notifications'

// AI Governance endpoints
export const AI_GOVERNANCE_PROXY = '/v3/governance'
// The governance service's internal routes (the overview's snapshot)
export const AI_GOVERNANCE_INTERNAL_PROXY = '/ai/governance'
// The MCP tool calls the account's agents made (agent-tool-call-worker-service)
export const AGENT_TOOL_CALLS_PROXY = '/v3/agent-tool-calls'

// The signed-in person's Slack links, held by notification-service and
// managed through the internal api
export const SLACK_USERS_PROXY = '/v1/config/integrations/slack/users'

// Audit service endpoints
export const AUDIT_PROXY = '/audit'

// Log Insights endpoints
export const LOG_INSIGHTS_PROXY = '/v3/log-insights'

// Metrics Insights endpoints
export const METRICS_PROXY = '/metrics'

// AI Memory endpoints
export const AI_MEMORY_PROXY = '/v1/ai-memory'

// Pipeline
export const PIPELINE = '/pipeline'
export const PIPELINE_FLOWRATE = '/pipeline/flowrate'

export const GET_ORGANIZATIONS_ENDPOINT = '/account/org/list'
export const JOIN_ORG_ENDPOINT = '/account/org/join'
export const LEAVE_ORG_ENDPOINT = '/account/org/leave'
export const GET_PIPELINE_ACCOUNT = '/account/pipeline/account'

export const BTN_COPIED_TIMEOUT = 2000

// UI Settings
export const TOAST_INTERVAL = 8000
export const TREND_GRADIENT = ['#7561B1', '#e81bcd']
export const MAX_ORG_NAME_LENGTH = 80

export const RESERVED_FIELDS = [
  '_account',
  '_id',
  '_app',
  '_host',
  '_env',
  'level',
  '_tag',
  '_label',
  '_ts',
  '_logtype',
  '_ingester',
  '_meta',
  '_rawline',
  '_line',
  'message',
  'timestamp',
  '_file',
  '_ip',
  '_ipremote',
  '_mac',
  '_source',
  '_type',
  'auth',
  'bytes',
  'connect',
  'method',
  'namespace',
  'path',
  'node',
  'container',
  'containerid',
  'pod',
  'request',
  'response',
  'service',
  'space',
  'status',
  'user',
  'dyno',
  '_multiline',
  '_parsefail',
  '__key',
  '_cluster',
  '_bid',
  '_parserids',
  '_deferred',
  '_noindex',
  '_platform',
  '_supertenant',
  'k8sclusterkey',
  '_mezmo_line_size',
  '_originating_user_agent'
]

export const SOURCE_KEYS = [
  'hosts',
  'apps',
  'tags',
  'levels'
]

export const CUSTOM_PARSE_RAW_LINE_LOG_TYPES = new Set(['syslog5424line', 'nxlog', 'cloudfoundry'])

export const ACCOUNT_STATUS_VALUES = {
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
  PENDING: 'pending'
}

export const BILLING_SYSTEMS = {
  OOTB: 'ootb',
  CLASSIC: 'classic'
}

export const PRODUCTS = {
  PIPELINE: 'pipeline',
  LOG_ANALYSIS: 'log-analysis'
}

export const BILLING_METHODOLOGY = {
  STORAGE: 'storage',
  INGESTION: 'ingestion'
}

export const LD_FEATURE_FLAGS = {
  HOMEPAGE_DASHBOARD: 'homepage-dashboard',
  INGESTION_BASED_PRICING: 'ingestion-based-pricing',
  USAGE_DASHBOARD_IN_SIZE: 'usage_dashboard_in_size',
  USAGE_DASHBOARD_RESPONSIVE_REDESIGN: 'usage-dashboard-responsive-redesign'
}

export const CATEGORY_TYPE = {
  views: 'views',
  federatedViews: 'federated views',
  boards: 'boards',
  screens: 'screens'
}
